import EditProfileAvatarDescriptionModal from './EditProfileAvatarDescriptionModal.container'
export default EditProfileAvatarDescriptionModal
